import { css } from "@emotion/react";

export const EasySizeStyles = css`
  @media (max-width: 700px) {
    body.es-size-advisor-open {
      overflow: hidden !important;
      position: fixed !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }
  #easysize_loading {
    position: fixed;
    top: 150px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .es-selected-size #easysize_button,
  .es-recommended-size #easysize_button {
    display: none;
  }
  .es-selected,
  .es-recommended {
    display: none;
    font-size: 12px;
  }
  .es-selected .easysize_button,
  .es-recommended .easysize_button {
    cursor: pointer;
    text-decoration: underline;
  }
  .es-selected-size .es-selected {
    display: block;
  }
  .es-recommended-size .es-recommended {
    display: block;
  }
  .easysize_button__returning,
  .easysize_button__out_of_stock {
    display: inline-block;
    line-height: 25px;
    font-weight: 500;
    position: relative;
    cursor: pointer;
  }
  .easysize_button__returning i,
  .easysize_button__out_of_stock i {
    display: inline-block;
    font-weight: bold;
    margin-left: 5px;
  }
  .easysize_button__returning:hover::after,
  .easysize_button__out_of_stock:hover::after {
    content: "";
    display: none;
    position: absolute;
    width: 100%;
    height: 1px;
    background: black;
  }
  .es-recommended-size #es-recommended {
    display: block;
  }
  .es-recommended-size #easysize_button {
    display: none;
  }
  .easysize_button {
    text-decoration: underline;
  }
  .easysize_button,
  .easysize_button__returning,
  .easysize_button__out_of_stock {
    position: relative;
    display: inline-block;
    color: black;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    margin: 10px 0;
    text-decoration: underline;
  }
  .easysize_button:before,
  .easysize_button__returning:before,
  .easysize_button__out_of_stock:before {
    content: "";
    display: inline-block;
    -webkit-mask: url("https://cdn.easysize.me/icons/Hanger%20Outline%201.svg") no-repeat;
    mask: url("https://cdn.easysize.me/icons/Hanger%20Outline%201.svg") no-repeat;
    height: 22px;
    width: 26px;
    margin-right: 5px;
    -webkit-mask-size: 26px auto;
    mask-size: 26px auto;
    background-color: black;
    position: relative;
    top: 9px;
  }
  .easysize_button__returning:before,
  .easysize_button__out_of_stock:before {
    -webkit-mask: url("https://cdn.easysize.me/icons/Checkmark%20Solid%201.svg") no-repeat;
    mask: url("https://cdn.easysize.me/icons/Checkmark%20Solid%201.svg") no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
    top: 4px;
  }
`;
